import { render, staticRenderFns } from "./ViewAttachments.vue?vue&type=template&id=2f5c35fa"
import script from "./ViewAttachments.vue?vue&type=script&lang=js"
export * from "./ViewAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports